<template>
  <section :id="$options.name" class="reviews">
    <h2 class="reviews__title">{{ reviews_count || ''}} Recensioni</h2>
    <div v-if="reviews_count">
      <b-row>
        <b-col
          v-for="(review, i) in first_reviews" 
          :key="'preview-' + (review.id || ('review-' + i))"
          class="reviews__preview"
          lg="4" md="6" sm="12"
        >
          <review   
            :rating="Number(review.rating)" 
            :reviewer="review.reviewer"
            :title="review.title"
            :content="review.text"
            :date="format_review_date(review)"
            :additional_data="review.verified_by" 
            truncate
          >
            <template v-slot:read-more>
              <b-button  
                @click="() => show_modal(review.id || ('review-' + i))"
                class="reviews__read_all" 
                variant="ghost" 
                v-b-modal="'modal_reviews'"
                vb-background-ghost
              >
                leggi tutto
              </b-button>
            </template>
          </review>
        </b-col>
      </b-row>
      <b-button v-if="reviews_count > MAX_REVIEWS" 
        class="reviews__show" 
        variant="ghost" 
        v-b-modal="'modal_reviews'"
        @click="() => show_modal()"
        role="button"
      >
        Mostra altre {{ reviews_count - MAX_REVIEWS }} recensioni
        <vb-icon
          :name="'angle_small_right'"
          :size=18
          :color="sass('info')"
        />
      </b-button>
    </div>
    <b-alert v-else class="reviews__alert" show>
      <p class="reviews__alert-title">Nessuna recensione da mostrare per la struttura.</p>
    </b-alert>
    <vb-modal 
      :modal_title="reviews_count + ' Recensioni'"
      :vb_options="{
        id: 'modal_reviews',
        size: 'lg',
        centered: true,
        hide_footer: true
      }"
    >
      <reviews-modal
        :reviews="reviews"
        :focused_review="focused_review"
      />
    </vb-modal>
  </section> 
</template>

<script>
import Review from '../../../../../components/blocks/review.vue';
import { format_review_date, get_reviews, MAX_REVIEWS } from '../../../utilities/reviews';
import ReviewsModal from './reviews-modal.vue'; 

export default {
  name: 'reviews',
  props: {
    property: Object, 
  }, 
  components: {
    'review': Review,
    'reviews-modal': ReviewsModal,
  },
  data() {
    return {
      MAX_REVIEWS,
      focused_review: '',
      reviews: [],
    }
  },
  created() {
    if (this.property) {
      // fetch reviews
      this.get_reviews(this.property.property_id)
        .then((res) => { 
          this.reviews = (res.data || {}).data || []
        })
        .catch((err) => {
          this.reviews = []
          this.log('[Reviews] - fetch error')
          this.log(err)
        })
    }
  },
  computed: {
    first_reviews() {
      return this.reviews.slice(0, this.MAX_REVIEWS);
    },
    reviews_count() {
      return this.reviews.length
    },
  }, 
  methods: { 
    get_reviews,
    format_review_date, 
    show_modal(focused_review = '') {
      this.focused_review = focused_review
    }
  },
}
</script>

<style lang="scss" scoped>

.reviews {

  @extend %section;
  @extend %section_margin;

  &__title {
    @extend %section__title;
  }

  &__preview {
    padding-bottom: $grid-gutter-width;
  }

  &__alert {
    border-radius: $border-radius-lg * 2;
    margin-bottom: 0;
    margin-top: $grid-gutter-20 * 2;
    background-color: $selected;
    border-color: transparent;

    &-title {
      margin-bottom: 0;
      color: $gray-900;
      font-weight: $vb-font-weight-semibold;
    }
  }

  &__show {
    display: flex;
    color: var(--info);
    text-decoration: underline;
    align-items: flex-end;
    padding: 0 !important;
  }

  &__read_all {
    font-size: $font-size-sm;
    font-style: italic;
    text-decoration: underline;
  }
}

</style>